import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  mainContainer: {
    backgroundColor: "#fff",
    alignItems: "center",
  },

  secondaryContainer: {
    backgroundColor: "white",
    height: 400,
    width: "70%",
    borderRadius: 8,
    borderColor: "#077A97",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  containerInfos: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  containerCardAtivo: {
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    gap: 12,
    marginTop: 40,
  },

  txtCarregando: {
    textAlign: "center",
    paddingVertical: 35,
    fontSize: 16,
  },

  content: {
    padding: 0,
    marginTop: 1,
  },

  text1: {
    fontWeight: "400",
    fontSize: 18,
    color: "#077a97",
    textTransform: "uppercase",
  },

  asset: {
    marginTop: 20,
    alignSelf: "center",
    width: 240,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: 6,
    backgroundColor: "#077A97",
    borderRadius: 4,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  asset_icon: {
    width: 24,
    height: 24,
    borderRadius: 50,
  },

  asset_name: {
    textTransform: "uppercase",
    fontSize: 14,
    color: "#FFF",
    fontWeight: "500",
    marginLeft: "5%",
  },

  category: {
    flexDirection: "column",
    marginHorizontal: 10,
    marginTop: 50,
    justifyContent: "center",
    borderRadius: 4,
    borderColor: "#077A97",
    borderWidth: 0.5,
  },

  categoryHeader: {
    flex: 1,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 15,
  },
  categoryBody: {
    padding: 15,
  },

  tabContent: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  tokens_list: {
    position: "absolute",
    bottom: 0,
    width: "90%",
    height: "42%",
    alignItems: "center",
    backgroundColor: "#fff",
    borderTopLeftRadius: 35,
    borderTopRightRadius: 35,
  },
  tokens_display_action: {
    alignItems: "center",
    paddingVertical: 10,
  },
  token: {
    flex: 1,
    padding: 10,
    borderWidth: 1,
    borderRadius: 4,
    marginBottom: 20,
    alignItems: "center",
    flexDirection: "row",
    borderColor: "#F4F4F4",
    justifyContent: "space-between",
  },
  scroll_view: {
    flex: 1,
    width: "100%",
    height: "30%",
    padding: 20,
    position: "absolute",
    top: "25%",
    height: "50%",
  },
  sectionHeader: {
    fontSize: 16,
    backgroundColor: "#fff",
    color: "#fff",
    fontWeight: "bold",
    padding: 15,
  },
  item: {
    flexDirection: "row",
    alignItems: "center",
    fontSize: 16,
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#666",
  },
  title: {
    fontSize: 16,
  },

  visualizarInformacao: {
    fontSize: 14,
    fontWeight: "bold",
  },

  btnsCategorias: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderColor: "#077A97",
    borderWidth: 0.5,
    backgroundColor: "#FFF",
    marginVertical: 12,
    alignSelf: "center",
  },
  categoryButtonText: {
    fontWeight: "500",
    fontSize: 14,
    textTransform: "uppercase",
    color: "#077A97",
  },
  categorySelectedBtnTxt: {
    fontWeight: "500",
    fontSize: 14,
    textTransform: "uppercase",
    color: "#FFF",
  },
  selectedButton: {
    backgroundColor: "#077A97",
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    marginVertical: 12,
    alignSelf: "center",
  },

  categoriasBtnsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-evenly",
    alignSelf: "center",
    gap: 20,
  },

  notAvailableContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },

  notAvailableText: {
    fontSize: 18,
    color: "#333",
    textAlign: "center",
  },
});

export default styles;
